"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeamQuoteTextProperty = exports.teamQuoteTextPropertyDefinition = void 0;
exports.teamQuoteTextPropertyDefinition = {
    view: { label: 'Text' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'team-quote-text',
};
const isTeamQuoteTextProperty = (prop) => {
    return prop.name === exports.teamQuoteTextPropertyDefinition.name;
};
exports.isTeamQuoteTextProperty = isTeamQuoteTextProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhbS1xdW90ZS10ZXh0LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdGVhbS1xdW90ZS10ZXh0LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsK0JBQStCLEdBQUc7SUFDN0MsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRTtJQUN2QixXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsaUJBQWlCO0NBQ1EsQ0FBQTtBQUkxQixNQUFNLHVCQUF1QixHQUFHLENBQUMsSUFBa0IsRUFBaUMsRUFBRTtJQUMzRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssdUNBQStCLENBQUMsSUFBSSxDQUFBO0FBQzNELENBQUMsQ0FBQTtBQUZZLFFBQUEsdUJBQXVCLDJCQUVuQyJ9